import type { LucideIcon } from 'lucide-react'
import {
  BarChart3,
  CalendarDays,
  CalendarRange,
  CheckCircle2,
  FileStack,
  GanttChartSquare,
  KanbanSquare,
  ListChecks,
  ListTodo,
  Megaphone,
  PartyPopper,
  Sun,
  Users,
} from 'lucide-react'

export interface NavItem {
  to: string
  label: string
  icon: LucideIcon
  end?: boolean
}

export interface NavGroup {
  title: string
  items: NavItem[]
}

/**
 * IA em torno do fluxo real: administrar posts por ambiente/campanha/evento,
 * ver cada etapa, o que falta, planejar. Views = ângulos do mesmo dado.
 */
export const NAV_GROUPS: NavGroup[] = [
  {
    title: 'Operação',
    items: [
      { to: '/', label: 'Hoje', icon: Sun, end: true },
      { to: '/kanban', label: 'Produção', icon: KanbanSquare },
      { to: '/pendencias', label: 'Pendências', icon: ListTodo },
      { to: '/calendario', label: 'Calendário', icon: CalendarDays },
      { to: '/semana', label: 'Semana', icon: CalendarRange },
    ],
  },
  {
    title: 'Gestão',
    items: [
      { to: '/campanhas', label: 'Campanhas', icon: Megaphone },
      { to: '/eventos', label: 'Eventos', icon: PartyPopper },
      { to: '/aprovacoes', label: 'Aprovações', icon: CheckCircle2 },
      { to: '/indicadores', label: 'Indicadores', icon: BarChart3 },
    ],
  },
  {
    title: 'Apoio',
    items: [
      { to: '/tarefas', label: 'Tudo', icon: ListChecks },
      { to: '/roadmap', label: 'Roadmap', icon: GanttChartSquare },
      { to: '/templates', label: 'Templates', icon: FileStack },
      { to: '/equipe', label: 'Equipe', icon: Users },
    ],
  },
]

export const NAV: NavItem[] = NAV_GROUPS.flatMap((g) => g.items)
